// extracted by mini-css-extract-plugin
module.exports = {"container":"panel_container__2UKbf"};